<!--新增编辑页面-->
<template>
    <div>
        <div class="button-area">
            <Button @click="save()" :loading="saveLoading" type="primary" class="button-right-left">保存</Button>
            <Button @click="back()" class="button-right">返回</Button>
        </div>
        <div class="form-area">
            <Form style="width: 900px" ref="form" :model="model" :rules="rules" :label-width="110" label-position="left" inline>
                <FormItem :class="{'model-hidden': true}" label="文本框">
                    <Input v-model="model.id" type="text"></Input>
                </FormItem>
                <FormItem label="用户姓名" prop="name">
                    <Input v-model="model.name" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="手机号" prop="phone">
                    <Input v-model="model.phone" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="职位" prop="duty">
                    <Input v-model="model.duty" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="部门" prop="deptname">
                    <Input v-model="model.deptname" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="地区" prop="area">
                    <Input v-model="model.area" style="width:320px" type="text"></Input>
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js'

    export default {
        name: 'tqtServiceAdministratorList',
        data () {
            return {

                //ID
                id: null,
                saveLoading: false,
                //表单参数
                model: {
                    id: null,
                    name: null,
                    phone: null,
                    password: null,
                    duty: null,
                    email: null,
                    address: null,
                    deptname: null,
                    isrealauth: null,
                    area: null,
                    // areaCode: null,
                    idCardBackPic: null,
                    isNeedChange: null,
                    type: 6
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                    phone: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                    ],
                    duty: [
                        { required: true, message: '请输入职位', trigger: 'blur' },
                    ],
                    deptname: [
                        { required: true, message: '请输部门', trigger: 'blur' },
                    ],
                    area: [
                        { required: true, message: '请输入地区', trigger: 'blur' },
                    ],
                }
            }
        },

        mounted () {
                if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
                this.id = this.$route.query.id
               // ID存在渲染表单
                this.initForm()
    }

        },
        methods: {
            //保存
            save () {
                this.$refs['form'].validate((valid) => {
                    if (!valid) {return}
                    if (this.row && this.row.id) {
                        this.update()
                    } else {
                        this.create()
                    }
                })
            },

            create () {
                let _this = this
                _this.saveLoading = true
                util.http.post('/api/serviceAdmin/insert', this.model, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {
                    _this.$Notice.success({
                        title: '保存成功!'
                    })
                    _this.back()
                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '保存失败!'
                    })
                    _this.saveLoading = false
                    console.log(error)
                })
            },

            update () {
                let _this = this
                _this.saveLoading = true
                util.http.post('/api/serviceAdmin/update', this.model, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {
                    _this.$Notice.success({
                        title: '更新成功!'
                    })
                    _this.back()
                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '更新失败!'
                    })
                    _this.saveLoading = false
                    console.log(error)
                })
            },

            //渲染表单
                initForm () {
                let _this = this
                util.http.get('/api/serviceAdmin/details/' + this.id).then(function (response) {
                    let tem = response.data
                    _this.model.name=tem.baseInfo.name || ''
                     _this.model.phone=tem.baseInfo.phone || ''
                      _this.model.deptname=tem.tqtServiceAdministratorInfo.deptname || ''
                       _this.model.duty=tem.tqtServiceAdministratorInfo.duty || ''
                    _this.model.area=tem.tqtServiceAdministratorInfo.area || ''
                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '获取表单失败!'
                    })
                    console.log(error)
                })
            },

            //返回,需要自定义配置路由
            back () {
                let _this = this
                let tagName = _this.$route.name
                _this.$store.commit('removeTag', tagName)
                _this.$store.commit('closePage', tagName)
                _this.$router.push({
                    name: 'tqt_service_administrator'
                })
            }
        }
    }
</script>

<style scoped>
    .button-area {
        display: flex;
        justify-content: flex-end;
    }

    .button-right-left {
        margin-right: 15px;
    }

    .button-right {
        margin-right: 55px;
    }

    .form-area {
        margin-top: 40px;
        display: flex;
        justify-content: center;
    }

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .model-hidden {
        display: none;
    }

</style>
